import { isEmpty, size } from 'lodash'
import { isValidPhoneNumber } from 'libphonenumber-js'

import formatters from 'helpers/formatters'

const isOptional = (value) => {
  if (isEmpty(value) || size(value) <= 3) return true
  return false
}

const schema = ({ value, required = false }) => {
  if (required) {
    if (isEmpty(value)) return false
  } else {
    if (isOptional(value)) return true
  }

  const phoneNumber = formatters.phone.withPrefix(value)
  return isValidPhoneNumber(phoneNumber)
}

export default { isOptional, schema }
